import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";
import {
  getPortalMessageCacheSection,
  setPortalMessageCacheSection,
} from "../utils/portalMessageCache";

export const profileSlice = createSlice({
  name: "profileSlice",
  initialState: {
    profileData: {},
    applicationProfileData: [],
    studentHoldData: [],
    profileDataEdit: {},
    errorMessage: undefined,
    dataFetchingStatus: false,
    errorStatusCode: undefined,
  },

  reducers: {
    setprofileData: (state, action) => {
      state.profileData = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setErrorStatusCode: (state, action) => {
      state.errorStatusCode = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
    removeElementsFromArray: (state, action) => {
      state.profileData = action.payload;
    },
    setProfileDataEditData: (state, action) => {
      state.profileDataEdit = action.payload;
    },
    setApplicationProfileData: (state, action) => {
      state.applicationProfileData = action.payload;
    },

    setStudentHoldData: (state, action) => {
      state.studentHoldData = action.payload;
    },
  },
});

export const {
  setprofileData,
  setErrorMessage,
  setDataFetchingStatus,
  removeElementsFromArray,
  setProfileDataEditData,
  setApplicationProfileData,
  setStudentHoldData,
  setErrorStatusCode,
} = profileSlice.actions;

export const getprofileData = (userId) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");

  axios
    .get(`profile/getContacts/${userId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setprofileData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getApplicationProfileData = (applicantId) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");

  axios
    .get(`application/profile/getContacts/${applicantId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setApplicationProfileData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getStudentHoldRecord =
  (studentId, options = {}) =>
  (dispatch) => {
    const { force = false } = options;
    const cachedHold = getPortalMessageCacheSection("studentHold");

    if (
      !force &&
      cachedHold &&
      cachedHold.studentId === studentId &&
      Array.isArray(cachedHold.data)
    ) {
      dispatch(setStudentHoldData(cachedHold.data));
      return Promise.resolve(cachedHold.data);
    }

    dispatch(removeElementsFromArray({}));
    dispatch(setDataFetchingStatus(true));
    dispatch(setErrorMessage(undefined));
    dispatch(setErrorStatusCode(undefined));
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + window.localStorage.getItem("x-auth-token");

    return axios
      .get(`studentholdrecod/${studentId}`)
      .then((response) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setStudentHoldData(response.data));
        setPortalMessageCacheSection("studentHold", {
          studentId,
          data: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setErrorMessage(error.response.data.error));
        dispatch(setErrorStatusCode(error.response.status));
        throw error;
      });
  };

export const postprofileData = (data) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post("profile/setContacts/", data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const clearprofileData = () => (dispatch) => {
  dispatch(removeElementsFromArray({}));
};

export const updateProfileEditData = (data) => (dispatch) => {
  dispatch(setProfileDataEditData(data));
};
export default profileSlice.reducer;
